import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/appStore';
import { Trash2, Edit2, Plus } from 'lucide-react';

export default function UserManager() {
  const { t } = useTranslation();
  const { users, addUser, deleteUser, updateUser } = useAppStore();
  const [newUserName, setNewUserName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');

  const handleAddUser = () => {
    if (newUserName.trim()) {
      addUser({
        name: newUserName,
        avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${Date.now()}`,
      });
      setNewUserName('');
    }
  };

  const handleEditUser = (id, name) => {
    setEditingId(id);
    setEditName(name);
  };

  const handleSaveEdit = (id) => {
    if (editName.trim()) {
      updateUser(id, { name: editName });
      setEditingId(null);
      setEditName('');
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-maroon">{t('dashboard.customizeNames')}</h3>

      <div className="space-y-3">
        <input
          type="text"
          value={newUserName}
          onChange={(e) => setNewUserName(e.target.value)}
          placeholder={t('dashboard.userName')}
          className="w-full bg-light border-2 border-primary/30 rounded-lg p-3 text-dark placeholder-dark/50 focus:outline-none focus:border-maroon transition"
          onKeyPress={(e) => e.key === 'Enter' && handleAddUser()}
        />
        <button
          onClick={handleAddUser}
          className="flex items-center gap-2 w-full bg-gradient-to-r from-maroon to-primary hover:shadow-lg text-light font-semibold py-2 px-4 rounded-lg transition"
        >
          <Plus size={18} />
          {t('dashboard.addUser')}
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-h-64 overflow-y-auto">
        {users.map((user) => (
          <div
            key={user.id}
            className="bg-light border-2 border-primary/30 hover:border-maroon rounded-lg p-3 transition"
          >
            <div className="flex flex-col items-center gap-2">
              <img
                src={user.avatar}
                alt={user.name}
                className="w-12 h-12 rounded-full border-2 border-primary"
              />
              {editingId === user.id ? (
                <div className="w-full space-y-2">
                  <input
                    type="text"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    className="w-full bg-light border-2 border-primary/30 rounded p-1 text-dark text-xs"
                  />
                  <div className="flex gap-1">
                    <button
                      onClick={() => handleSaveEdit(user.id)}
                      className="flex-1 bg-maroon/20 hover:bg-maroon/30 text-maroon py-1 px-2 rounded text-xs transition font-semibold"
                    >
                      {t('dashboard.save')}
                    </button>
                    <button
                      onClick={() => setEditingId(null)}
                      className="flex-1 bg-light border-2 border-primary/30 hover:border-maroon py-1 px-2 rounded text-xs transition"
                    >
                      {t('dashboard.cancel')}
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <p className="text-sm font-semibold text-maroon text-center truncate w-full">
                    {user.name}
                  </p>
                  <div className="flex gap-1 w-full">
                    <button
                      onClick={() => handleEditUser(user.id, user.name)}
                      className="flex-1 p-1 hover:bg-maroon/20 rounded transition text-maroon text-xs"
                    >
                      <Edit2 size={14} className="mx-auto" />
                    </button>
                    <button
                      onClick={() => deleteUser(user.id)}
                      className="flex-1 p-1 hover:bg-red-500/20 rounded transition text-red-500 text-xs"
                    >
                      <Trash2 size={14} className="mx-auto" />
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
